import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { api_url } from '../../helpers/apiHelpers';
import { Link } from 'react-router-dom';

const ContactData = () => {

    const [allContactData, setAllContactData] = useState([]);

    const getAllData = async () => {
        const response = await fetch(`${api_url}/api/admin/get-contact-data`);

        const result = await response.json();
        if (result.status === 201) {
            setAllContactData(result.result);
        } else {
            setAllContactData([]);
        }
    };

    useEffect(() => {
        getAllData();
    }, []);


    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = allContactData.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(allContactData.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className="flex-1 overflow-auto relative z-10 p-4">
            <h2 className="mb-3 font-semibold text-2xl text-black text-center bg-[#c6e920] py-2 rounded-lg shadow-lg transition-transform duration-300">
                See All Contact Data Of Digital Parag
            </h2>
            <div className="mx-0">
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="overflow-x-auto w-full max-w-[20rem] sm:max-w-full"
                >
                    <table className="table table-bordered table-responsive">
                        <thead>
                            <tr className="bg-gradient-to-r from-orange-100 to-orange-300">
                                <th >#</th>
                                <th >Name</th>
                                <th >Email </th>
                                <th > Mobile No.</th>
                                <th >Subject</th>
                                <th >Comment</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((admin, index) => (
                                <tr key={admin.id} className="bg-white">
                                    <td >
                                        {index + 1 + (currentPage - 1) * itemsPerPage}
                                    </td>
                                    <td >{admin.name}</td>
                                    <td >
                                        <Link className='' to={`mailto:${admin.email}`}>{admin.email}</Link>
                                    </td>
                                    <td >{admin.mobile}</td>
                                    <td >{admin.subject}</td>
                                    <td >{admin.message}</td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </motion.div>
                <div className="flex justify-between mt-4">
                    <button
                        onClick={prevPage}
                        className="px-4 py-2 bg-[#b0c22a] text-white rounded hover:bg-orange-400"
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span className="text-gray-600">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        onClick={nextPage}
                        className="px-4 py-2 bg-[#b0c22a] text-white rounded hover:bg-orange-400"
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ContactData
